import {
  Button,
  ButtonProps,
  Icon,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
import { useTheme } from "next-themes";
import { MdDarkMode, MdLightMode } from "react-icons/md";

export const useToggleTheme = () => {
  const { theme, setTheme } = useTheme();
  const { colorMode, toggleColorMode } = useColorMode();

  const toggleTheme = () => {
    switch (colorMode) {
      case "dark": {
        setTheme("light");
        break;
      }
      case "light": {
        setTheme("dark");
        break;
      }
    }
    toggleColorMode();
  };

  return toggleTheme;
};

export const ToggleThemeButton = (props?: ButtonProps) => {
  const toggleTheme = useToggleTheme();

  const ColorModeIcon = useColorModeValue(MdDarkMode, MdLightMode);

  return (
    <Button {...props} onClick={toggleTheme}>
      <Icon as={ColorModeIcon} />
    </Button>
  );
};
